type Status = "ok" | "warn" | "danger";

const dot: Record<Status, string> = {
  ok: "bg-ok",
  warn: "bg-warn",
  danger: "bg-danger",
};

export function ChannelListItem({
  name,
  sla,
  status = "ok",
}: {
  name: string;
  sla?: string;
  status?: Status;
}) {
  return (
    <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:bg-[rgba(233,242,238,0.06)]">
      <span className={`inline-block w-[7px] h-[7px] rounded-full ${dot[status]}`} />
      <span className="text-[12.5px] text-on-dark">#{name}</span>
      {sla && (
        <span className="ml-auto text-[10.5px] font-mono text-on-dark-faint">
          {sla}
        </span>
      )}
    </div>
  );
}
